document.addEventListener('DOMContentLoaded', function() {

  const LR_FUNCTION_URL = 'https://libro-reclamaciones-299960328167.southamerica-east1.run.app';

  var btnEnviar = document.getElementById('lr-btn-enviar');
  var btnPrint = document.getElementById('lr-btn-print');
  var btnDescargar = document.getElementById('lr-btn-descargar');

  if (btnEnviar) btnEnviar.addEventListener('click', lrEnviar);
  if (btnPrint) btnPrint.addEventListener('click', lrImprimir);
  if (btnDescargar) btnDescargar.addEventListener('click', lrDescargarPDF);

  // LÓGICA MAYOR / MENOR DE EDAD
  var chkMayor = document.getElementById('lr-mayor-edad');
  var chkMenor = document.getElementById('lr-menor-edad');
  var apoderadoSeccion = document.getElementById('lr-apoderado-seccion');

  if (chkMayor) {
    chkMayor.addEventListener('change', function() {
      if (this.checked) {
        chkMenor.checked = false;
        apoderadoSeccion.classList.remove('visible');
        limpiarApoderado();
      }
    });
  }

  if (chkMenor) {
    chkMenor.addEventListener('change', function() {
      if (this.checked) {
        chkMayor.checked = false;
        apoderadoSeccion.classList.add('visible');
      } else {
        apoderadoSeccion.classList.remove('visible');
        limpiarApoderado();
      }
    });
  }

  function limpiarApoderado() {
    var campos = ['lr-apoderado-tipo-doc','lr-apoderado-num-doc','lr-apoderado-nombres','lr-apoderado-apellidos','lr-apoderado-email','lr-apoderado-telefono'];
    campos.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.value = '';
    });
  }

  function esMenorDeEdad() {
    return chkMenor && chkMenor.checked;
  }

  function lrValidar() {
    let valido = true;

    const requeridos = [
      { id: 'lr-nombres', fieldId: 'field-nombres' },
      { id: 'lr-apellidos', fieldId: 'field-apellidos' },
      { id: 'lr-tipo-doc', fieldId: 'field-documento' },
      { id: 'lr-num-doc', fieldId: 'field-num-doc' },
      { id: 'lr-telefono', fieldId: 'field-telefono' },
      { id: 'lr-tipo-bien', fieldId: 'field-tipo-bien' },
      { id: 'lr-descripcion-bien', fieldId: 'field-descripcion-bien' },
      { id: 'lr-detalle', fieldId: 'field-detalle' },
    ];

    requeridos.forEach(({ id, fieldId }) => {
      const el = document.getElementById(id);
      const field = document.getElementById(fieldId);
      if (!el.value.trim()) {
        field.classList.add('has-error');
        valido = false;
      } else {
        field.classList.remove('has-error');
      }
    });

    const email = document.getElementById('lr-email');
    const fieldEmail = document.getElementById('field-email');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.value.trim())) {
      fieldEmail.classList.add('has-error');
      valido = false;
    } else {
      fieldEmail.classList.remove('has-error');
    }

    // Validar edad seleccionada
    var edadError = document.getElementById('field-edad-error');
    if (!chkMayor.checked && !chkMenor.checked) {
      edadError.style.display = 'block';
      valido = false;
    } else {
      edadError.style.display = 'none';
    }

    // Validar apoderado si es menor de edad
    if (esMenorDeEdad()) {
      const camposApoderado = [
        { id: 'lr-apoderado-tipo-doc', fieldId: 'field-apoderado-tipo-doc' },
        { id: 'lr-apoderado-num-doc', fieldId: 'field-apoderado-num-doc' },
        { id: 'lr-apoderado-nombres', fieldId: 'field-apoderado-nombres' },
        { id: 'lr-apoderado-apellidos', fieldId: 'field-apoderado-apellidos' },
        { id: 'lr-apoderado-telefono', fieldId: 'field-apoderado-telefono' },
      ];
      camposApoderado.forEach(({ id, fieldId }) => {
        const el = document.getElementById(id);
        const field = document.getElementById(fieldId);
        if (!el.value.trim()) {
          field.classList.add('has-error');
          valido = false;
        } else {
          field.classList.remove('has-error');
        }
      });
    }

    const tipoReclamo = document.querySelector('input[name="lr-tipo-reclamo"]:checked');
    const errorTipo = document.getElementById('field-tipo-reclamo-error');
    if (!tipoReclamo) {
      errorTipo.style.display = 'block';
      valido = false;
    } else {
      errorTipo.style.display = 'none';
    }

    const consentimiento = document.getElementById('lr-consentimiento');
    const errorConsentimiento = document.getElementById('field-consentimiento-error');
    if (!consentimiento.checked) {
      errorConsentimiento.style.display = 'block';
      valido = false;
    } else {
      errorConsentimiento.style.display = 'none';
    }

    return valido;
  }

  async function lrEnviar() {
    if (!lrValidar()) {
      window.scrollTo({ top: document.querySelector('.lr-form-container').offsetTop - 20, behavior: 'smooth' });
      return;
    }

    const btn = document.getElementById('lr-btn-enviar');
    const loading = document.getElementById('lr-loading');
    const formSections = document.querySelectorAll('.lr-section, .lr-submit-area');

    btn.disabled = true;
    formSections.forEach(s => s.style.display = 'none');
    loading.style.display = 'block';

    const tipoReclamo = document.querySelector('input[name="lr-tipo-reclamo"]:checked').value;

    const datos = {
      nombres: document.getElementById('lr-nombres').value.trim(),
      apellidos: document.getElementById('lr-apellidos').value.trim(),
      tipoDoc: document.getElementById('lr-tipo-doc').value,
      numDoc: document.getElementById('lr-num-doc').value.trim(),
      telefono: document.getElementById('lr-telefono').value.trim(),
      email: document.getElementById('lr-email').value.trim(),
      direccion: document.getElementById('lr-direccion').value.trim(),
      edad: chkMenor.checked ? 'Menor de Edad' : 'Mayor de Edad',
      apoderado: esMenorDeEdad() ? {
        tipoDoc: document.getElementById('lr-apoderado-tipo-doc').value,
        numDoc: document.getElementById('lr-apoderado-num-doc').value.trim(),
        nombres: document.getElementById('lr-apoderado-nombres').value.trim(),
        apellidos: document.getElementById('lr-apoderado-apellidos').value.trim(),
        email: document.getElementById('lr-apoderado-email').value.trim(),
        telefono: document.getElementById('lr-apoderado-telefono').value.trim(),
      } : null,
      tipoBien: document.getElementById('lr-tipo-bien').value,
      monto: document.getElementById('lr-monto').value,
      descripcionBien: document.getElementById('lr-descripcion-bien').value.trim(),
      numPedido: document.getElementById('lr-num-pedido').value.trim(),
      fechaCompra: document.getElementById('lr-fecha-compra').value,
      tipoReclamo: tipoReclamo,
      detalle: document.getElementById('lr-detalle').value.trim(),
      pedido: document.getElementById('lr-pedido').value.trim(),
    };

    try {
      const response = await fetch(LR_FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos)
      });

      if (!response.ok) throw new Error('Error en el servidor');

      const result = await response.json();
      loading.style.display = 'none';
      lrMostrarConfirmacion(result, datos);

    } catch (error) {
      loading.style.display = 'none';
      formSections.forEach(s => s.style.display = '');
      btn.disabled = false;
      alert('Ocurrió un error al enviar su reclamación. Por favor intente nuevamente o contáctenos directamente.');
      console.error(error);
    }
  }

  function lrMostrarConfirmacion(result, datos) {
    const confirmacion = document.getElementById('lr-confirmacion');
    confirmacion.style.display = 'block';

    const ahora = new Date();
    const fechaHora = ahora.toLocaleString('es-PE', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });

    document.getElementById('lr-email-confirmado').textContent = datos.email;
    document.getElementById('lr-ticket-num').textContent = result.ticket || '-';
    document.getElementById('lr-fecha-hora').textContent = fechaHora;
    document.getElementById('lr-tipo-confirmado').textContent = datos.tipoReclamo;

    document.getElementById('hoja-ticket').textContent = result.ticket || '-';
    document.getElementById('hoja-nombre').textContent = datos.apellidos + ', ' + datos.nombres;
    document.getElementById('hoja-doc').textContent = datos.tipoDoc + ': ' + datos.numDoc;
    document.getElementById('hoja-telefono').textContent = datos.telefono;
    document.getElementById('hoja-email').textContent = datos.email;
    document.getElementById('hoja-direccion').textContent = datos.direccion || '-';
    document.getElementById('hoja-edad').textContent = datos.edad;

    var apoderadoHoja = document.getElementById('hoja-apoderado-seccion');
    if (datos.apoderado && apoderadoHoja) {
      apoderadoHoja.style.display = 'block';
      document.getElementById('hoja-apoderado-nombre').textContent = datos.apoderado.apellidos + ', ' + datos.apoderado.nombres;
      document.getElementById('hoja-apoderado-doc').textContent = datos.apoderado.tipoDoc + ': ' + datos.apoderado.numDoc;
      document.getElementById('hoja-apoderado-telefono').textContent = datos.apoderado.telefono;
      document.getElementById('hoja-apoderado-email').textContent = datos.apoderado.email || '-';
    } else if (apoderadoHoja) {
      apoderadoHoja.style.display = 'none';
    }
    document.getElementById('hoja-tipo-bien').textContent = datos.tipoBien;
    document.getElementById('hoja-monto').textContent = datos.monto ? 'S/ ' + parseFloat(datos.monto).toFixed(2) : '-';
    document.getElementById('hoja-desc-bien').textContent = datos.descripcionBien;
    document.getElementById('hoja-num-pedido').textContent = datos.numPedido || '-';
    document.getElementById('hoja-fecha-compra').textContent = datos.fechaCompra || '-';
    document.getElementById('hoja-tipo-reclamo').textContent = datos.tipoReclamo;
    document.getElementById('hoja-fecha-presentacion').textContent = fechaHora;
    document.getElementById('hoja-detalle').textContent = datos.detalle;
    document.getElementById('hoja-pedido').textContent = datos.pedido || '-';

    confirmacion.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function lrImprimir() {
    document.getElementById('lr-hoja-imprimible').style.display = 'block';
    window.print();
  }

  function lrDescargarPDF() {
    var hoja = document.getElementById('lr-hoja-imprimible');
    hoja.style.display = 'block';
    var ticket = document.getElementById('hoja-ticket').textContent || 'reclamacion';
    var contenido = hoja.innerHTML;

    var css = '*{box-sizing:border-box;margin:0;padding:0}'
      + 'body{font-family:sans-serif;background:white;color:#1a1a1a}'
      + '#lr-hoja-imprimible{display:block!important;padding:30px;max-width:750px;margin:0 auto}'
      + '.hoja-header{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #C0392B;padding-bottom:20px;margin-bottom:24px}'
      + '.hoja-titulo h1{font-size:22px;color:#C0392B;margin:0 0 4px}'
      + '.hoja-titulo p{font-size:12px;color:#6b6560}'
      + '.hoja-correlativo{text-align:right}'
      + '.corr-label{font-size:10px;text-transform:uppercase;color:#6b6560;display:block}'
      + '.corr-num{font-size:18px;font-weight:700;color:#C0392B;display:block}'
      + '.hoja-empresa{background:#F2EDE8;padding:14px 18px;border-radius:6px;margin-bottom:20px;font-size:13px;line-height:1.8}'
      + '.hoja-empresa strong{font-size:14px;display:block;margin-bottom:4px}'
      + '.hoja-seccion{margin-bottom:20px}'
      + '.hoja-seccion h3{font-size:11px;font-weight:700;text-transform:uppercase;color:#C0392B;border-bottom:1px solid #D5CFC8;padding-bottom:6px;margin-bottom:12px}'
      + '.hoja-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}'
      + '.hoja-campo{font-size:12px}'
      + '.campo-label{color:#6b6560;font-weight:500;display:block;margin-bottom:2px}'
      + '.campo-valor{color:#1a1a1a;border-bottom:1px solid #D5CFC8;padding-bottom:4px;display:block;min-height:20px}'
      + '.hoja-campo-full{grid-column:1 / -1}'
      + '.hoja-detalle{font-size:13px;line-height:1.7;padding:12px;background:#FAF7F2;border-radius:4px;border:1px solid #D5CFC8;min-height:80px}'
      + '.hoja-footer{margin-top:32px;padding-top:16px;border-top:1px solid #D5CFC8;display:grid;grid-template-columns:1fr 1fr;gap:40px;font-size:11px;color:#6b6560}'
      + '.hoja-firma{text-align:center}'
      + '.firma-linea{border-top:1px solid #1a1a1a;margin-bottom:6px;margin-top:48px}';

    var html = '<!DOCTYPE html><html><head><meta charset="UTF-8">'
      + '<title>Hoja-Reclamacion-' + ticket + '</title>'
      + '<style>' + css + '</style></head>'
      + '<body onload="window.print();setTimeout(function(){window.close()},2000)">'
      + '<div id="lr-hoja-imprimible">' + contenido + '</div>'
      + '</body></html>';

    var blob = new Blob([html], { type: 'text/html' });
    var url = URL.createObjectURL(blob);
    var ventana = window.open(url, '_blank');
    if (!ventana) {
      alert('Por favor permite las ventanas emergentes para descargar el PDF.');
    }
    setTimeout(function() { URL.revokeObjectURL(url); }, 10000);
    hoja.style.display = 'none';
  }

});